import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_navigation_ui_header = _resolveComponent("navigation-ui-header")!
  const _component_valuation_range_smart_ui = _resolveComponent("valuation-range-smart-ui")!
  const _component_hero_container = _resolveComponent("hero-container")!
  const _component_advantages_section = _resolveComponent("advantages-section")!
  const _component_table_of_contents = _resolveComponent("table-of-contents")!
  const _component_reasons_to_use = _resolveComponent("reasons-to-use")!
  const _component_estimation_steps_section = _resolveComponent("estimation-steps-section")!
  const _component_estimation_cost = _resolveComponent("estimation-cost")!
  const _component_data_protection_section = _resolveComponent("data-protection-section")!
  const _component_navigation_ui_footer = _resolveComponent("navigation-ui-footer")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.isMobile ? 'is-mobile' : 'is-desktop'])
  }, [
    _createVNode(_component_navigation_ui_header),
    (_ctx.valuationRangeOpened)
      ? (_openBlock(), _createBlock(_component_valuation_range_smart_ui, {
          key: 0,
          class: "theme-immowelt"
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _createVNode(_component_hero_container),
      _createVNode(_component_advantages_section),
      _createVNode(_component_table_of_contents),
      _createVNode(_component_reasons_to_use),
      _createVNode(_component_estimation_steps_section),
      _createVNode(_component_estimation_cost),
      _createVNode(_component_data_protection_section)
    ]),
    _createVNode(_component_navigation_ui_footer)
  ], 2))
}